import { Box, Button, Modal, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { ControlledRadioGroup } from '../../../../components/ControlledRadioInput/ControlledRadioGroup'
import { setConclusion } from '../../../../pages/Meds/MedCardPageModel'
import { setBase64File, setMedCardInfo } from '../../../../pages/Meds/MedExamsSlice'
import { activeColor } from '../../../../pages/Meds/styles/styles'
import { ICertificate, getAvailableCertificates } from '../../../../services/cryptoService'
import { ModalNames, setCurrentApiUrl } from '../../../../slices/AppSlice'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks/redux'
import { IModalProps } from './props'
import { useModal } from './useModal'
import * as Sentry from "@sentry/react";

export const ConclusionModal = ({ open, handleClose }: IModalProps) => {
  const { control, handleSubmit, getValues } = useForm()

  const { changeCurrentModal } = useModal()

  const { card, medicalReport, currentCertificate } = useAppSelector(state => state.examReducer)
  const { medic } = useAppSelector(state => state.mainReducer)
  const { currentApiUrl } = useAppSelector(state => state.appReducer)
  const dispatch = useAppDispatch()
  const [certificates, setCertificates] = useState<any>([])
  const [isCertificatesLoading, setLoadingCertificates] = useState(false)

  const onSubmit = async (/*data: any*/) => {
    console.log('[CERTIFICATE_MODAL] Начало процесса подписания')
    try {
      // console.log('[CERTIFICATE_MODAL] Выбранный thumbprint:', data.thumbprint)
      // const currentCertificate = certificates.find(
      //   (item: any) => item.thumbprint === data.thumbprint
      // )

      if (!currentCertificate) {
        console.error('[CERTIFICATE_MODAL] Сертификат не найден в списке доступных')
        changeCurrentModal(ModalNames.ECP_ERROR)
        return
      }

      console.log('[CERTIFICATE_MODAL] Информация о сертификате:', {
        thumbprint: currentCertificate.thumbprint,
        validFrom: currentCertificate.validFrom,
        validTo: currentCertificate.validTo,
      })

      if (medicalReport && medic.id) {
        changeCurrentModal(ModalNames.ECP_SIGNING)
        const thumbprint = currentCertificate.thumbprint
        const activeFrom = currentCertificate.validFrom
        const activeTo = currentCertificate.validTo

        console.log('[CERTIFICATE_MODAL] Получение информации о владельце сертификата')
        const ownerInfo = await currentCertificate?.getOwnerInfo()
        console.log('[CERTIFICATE_MODAL] Информация о владельце:', ownerInfo)

        const certificateObj: ICertificate = {
          value: thumbprint,
          owner: !!ownerInfo
            ? `${ownerInfo[0].description} ${ownerInfo[1].description}`
            : undefined,
          active_from: activeFrom,
          active_to: activeTo,
        }

        console.log('[CERTIFICATE_MODAL] Подготовка к подписанию:', {
          medicalReportId: medicalReport.id,
          medicId: medic.id,
          certificateOwner: certificateObj.owner,
        })

        let result
        if (currentApiUrl) {
          await Sentry.startNewTrace(async () => {
            await Sentry.startSpan(
              { op: "medCard.model.setConclusion", name: "signing EDS" },
              async () => {
                result = await setConclusion(currentApiUrl, card, medicalReport, medic.id!, certificateObj)
              },
            )
          })
          // result = await setConclusion(currentApiUrl, card, medicalReport, medic.id, certificateObj)
          console.log('[CERTIFICATE_MODAL] Результат подписания:', !!result)
        } else {
          console.log('[CERTIFICATE_MODAL] Отсутствует URL API')
        }

        // if (result) {
        //   console.log('[CERTIFICATE_MODAL] Подписание успешно завершено')
        //   changeCurrentModal(ModalNames.SUCCESS)
        // } else {
        //   console.error('[CERTIFICATE_MODAL] Ошибка при подписании')
        //   changeCurrentModal(ModalNames.ECP_ERROR)
        // }
        if (result) {
          console.log(result)
          changeCurrentModal(result as ModalNames)

          dispatch(setMedCardInfo(null))
          dispatch(setCurrentApiUrl(undefined))
          dispatch(setBase64File(undefined))
        }
      } else {
        console.error('[CERTIFICATE_MODAL] Отсутствуют необходимые данные:', {
          hasMedicalReport: !!medicalReport,
          hasMedicId: !!medic.id,
        })
        changeCurrentModal(ModalNames.ECP_ERROR)
      }
    } catch (error: any) {
      console.error('[CERTIFICATE_MODAL] Критическая ошибка при подписании:', {
        message: error.message,
        stack: error.stack,
        name: error.name,
      })
      changeCurrentModal(ModalNames.ECP_ERROR)
    }
  }

  useEffect(() => {
    ;(async () => {
      // console.log('[CERTIFICATE_MODAL] Начало загрузки сертификатов')
      // setLoadingCertificates(state => (state = true))
      // try {
      //   const certificates = await getAvailableCertificates()
      //   console.log('[CERTIFICATE_MODAL] Загружено сертификатов:', certificates?.length || 0)

      //   if (!!certificates) {
      //     setCertificates((state: any) => (state = certificates))
      //     console.log('[CERTIFICATE_MODAL] Сертификаты успешно установлены в состояние')
      //   } else {
      //     console.error('[CERTIFICATE_MODAL] Не удалось получить список сертификатов')
      //   }
      // } catch (error: any) {
      //   console.error('[CERTIFICATE_MODAL] Ошибка при загрузке сертификатов:', {
      //     message: error.message,
      //     stack: error.stack,
      //     name: error.name,
      //   })
      // } finally {
      //   setLoadingCertificates(state => (state = false))
      // }
      onSubmit()
    })()
  }, [])

  return (
    <Modal open={/*open*/false} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'background.paper',

          width: '526px',
          //maxHeight: '320px',
          borderRadius: '4px',
          border: 'none',
          padding: '24px',

          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          gap: '24px',

          '& h2': {
            fontSize: '24px',
            fontWeight: '600',
            lineHeight: '28px',
            color: '#3E3E3E',
            //whiteSpace: 'nowrap',
          },

          // '& p': {
          //   fontSize: '16px',
          //   fontWeight: '400',
          //   color: '#3E3E3E',
          //   lineHeight: '28px',
          // },
        }}>
        {isCertificatesLoading ? (
          <Typography>Идет загрузка сертификатов...</Typography>
        ) : (
          <Box
            sx={{
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',

              gap: '12px',
            }}>
            <h2>Выберите сертификат ЭЦП для подписания заключения</h2>
            {certificates.length > 0 ? (
              <Stack spacing={2}>
                <ControlledRadioGroup
                  name='thumbprint'
                  control={control}
                  options={certificates.map((certificate: any) => {
                    return {
                      label: certificate.name,
                      value: certificate.thumbprint,
                    }
                  })}
                />

                <Button
                  onClick={
                    handleSubmit(onSubmit)
                    // handleClose()
                  }
                  disabled={!getValues('thumbprint')}
                  sx={{
                    alignSelf: 'center',
                    width: '227px',
                    height: '36px',
                    backgroundColor: activeColor,
                    padding: '10px 12px',
                    borderRadius: '4px',
                    color: '#FFFFFF',
                    textTransform: 'none',
                    fontSize: '14px',
                    fontWeight: '500',
                    lineHeight: '16px',
                    whiteSpace: 'nowrap',
                    '&:hover': {
                      backgroundColor: '#DD2D2F',
                    },
                  }}>
                  Подписать
                </Button>
              </Stack>
            ) : (
              <Typography>Сертификаты не найдены</Typography>
            )}
          </Box>
        )}
      </Box>
    </Modal>
  )
}
